export default __webpack_public_path__ + "static/media/office_building.b783ccce.png";